export default function SvgToggleActive() {
    return (
      <>
      <svg
      xmlns="http://www.w3.org/2000/svg"
      width="35px"
      cursor="pointer"
      fill="none"
      viewBox="0 0 24 24"
    >
      <path
        fill="blue"
        fillRule="evenodd"
        d="M7 6h10a6 6 0 010 12H7A6 6 0 017 6zm13 6a3 3 0 11-6 0 3 3 0 016 0z"
        clipRule="evenodd"
      ></path>
    </svg>
    </>
  );
}